export class RemarkScrollPoint {
  constructor(
    readonly segmentId: string,
    readonly remarkId: string,
    readonly smooth: boolean,
  ) {}
}
